import { ClassName } from '@busybusy/webapp-react-ui';
import FlexContainer from '@busybusy/webapp-react-ui/dist/components/FlexContainer/FlexContainer';
import classNames from 'classnames';
import { ReactNode } from 'react';
import './DashboardRibbonGroup.scss';

export interface IDashboardRibbonGroupProps {
  children: ReactNode;
  className?: ClassName;
}

export default function DashboardRibbonGroup({ children, className }: IDashboardRibbonGroupProps) {
  const classes = classNames('dashboard-ribbon-group', className);
  return (
    <FlexContainer className={classes} flexDirection="column">
      {children}
    </FlexContainer>
  );
}
